import MultiSortPanel from './MultiSortPanel.component';

export default MultiSortPanel;
